import { useEffect } from "react";
import { store } from "../../app/store";
import { Outlet } from "react-router-dom";
import { notesApiSlice } from "../notes/notesApiSlice";
import { userApiSlice } from "../user/userApiSlice";
import { labelsApiSlice } from "../labels/labelsApiSlice";
function Prefetch() {
  useEffect(() => {
    store.dispatch(
      notesApiSlice.util.prefetch("getNotes", "notesList", { force: true })
    );
    store.dispatch(
      userApiSlice.util.prefetch("getUser", "User", { force: true })
    );
    store.dispatch(
      labelsApiSlice.util.prefetch("getLabels", "labelsList", { force: true })
    );
  }, []);

  return <Outlet />;
}

export default Prefetch;
